<template>
  <div class="abilitySpark">
    <div>
      <div class="sparkTitle fz16 bl">
        精心打造300个精英事务
      </div>
      <div class="c666" style="margin-top: 16px;">
        着眼于保险行业未来发展趋势，顺应新时期保险消费主体的消费逻辑和消费特点，专注于构建开放性和多元化的保险创业服务平台，通过星火计划吸引和培育符合未来综合金融发展趋势的保险精英团队，探索独立代理人的创业模式。致力于打造一个更具开放式，更具创新性，更加多元化，更加包容性的创业服务平台。
      </div>
    </div>
    <div>
      <img src="../assets/images/picture_30.png" alt="">
    </div>

  </div>
</template>

<script>
  export default {
    name: 'abilitySpark',
    components: {},
    data() {
      return {}
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .abilitySpark {
    width: 1024px;
    margin: 0 auto;
    &>div {
      margin-top: 40px;

      img {
        width: 100%;
      }
    }
  }
</style>